import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-resume-quoter',
  templateUrl: `./resume-quoter.component${environment.templateSuffix}.html`,
  styleUrls: ['./resume-quoter.component.scss']
})
export class ResumeQuoterComponent {
  @Input() brand!: any;
  @Input() subBrand!: any;
  @Input() version!: any;
  @Input() year!: any;
  @Input() priceWithIva!: any;
  @Input() insurance!: any;
  @Input() stateName!: any;
  @Input() ri!:any;
  @Input() concept!:any;
  @Input() period!:any;
  @Input() initialPayment!:any;
  @Input() monthlyPayment!:any;
  @Input() isMaxAdvancedRent: boolean = false;
  @Input() isRecalculated: boolean = false;
  @Input() showTitle: boolean = false;
  @Input() textHeader: string = '';
  @Input() purchaseValue!:any;
  @Input() isMaxPurchaseValue: boolean = false;
  @Input() appliedCode: boolean = false;
  @Input() isDropDown: boolean = false;
  @Input() isCredit: boolean = false;
  @Input() hitch: any = 0;
  @Input() annuity: any = 0;
  @Input() ballon?: number = 0;
  @Input() rate: any = 0;
  @Input() cat: any = 0;
  @Input() isBallon: boolean = false;
  showComplete: boolean = true;
}
